/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestDetail
 */
export interface AccessRequestDetail {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    app_external_connection_id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    identifier_from_source: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    external_identity_id: string;
    /**
     * Person ID
     * @type {string}
     * @memberof AccessRequestDetail
     */
    person_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    target: string;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestDetail
     */
    requested_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestDetail
     */
    expires_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    revert_action?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    revert_action_target?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestDetail
     */
    reverted?: boolean;
}

/**
 * Check if a given object implements the AccessRequestDetail interface.
 */
export function instanceOfAccessRequestDetail(value: object): value is AccessRequestDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('app_external_connection_id' in value) || value['app_external_connection_id'] === undefined) return false;
    if (!('identifier_from_source' in value) || value['identifier_from_source'] === undefined) return false;
    if (!('external_identity_id' in value) || value['external_identity_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function AccessRequestDetailFromJSON(json: any): AccessRequestDetail {
    return AccessRequestDetailFromJSONTyped(json, false);
}

export function AccessRequestDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organization_id': json['organization_id'],
        'app_external_connection_id': json['app_external_connection_id'],
        'identifier_from_source': json['identifier_from_source'],
        'external_identity_id': json['external_identity_id'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'status': json['status'],
        'action': json['action'],
        'target': json['target'],
        'requested_at': json['requested_at'] == null ? undefined : (new Date(json['requested_at'])),
        'expires_at': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'revert_action': json['revert_action'] == null ? undefined : json['revert_action'],
        'revert_action_target': json['revert_action_target'] == null ? undefined : json['revert_action_target'],
        'reverted': json['reverted'] == null ? undefined : json['reverted'],
    };
}

export function AccessRequestDetailToJSON(json: any): AccessRequestDetail {
    return AccessRequestDetailToJSONTyped(json, false);
}

export function AccessRequestDetailToJSONTyped(value?: AccessRequestDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'app_external_connection_id': value['app_external_connection_id'],
        'identifier_from_source': value['identifier_from_source'],
        'external_identity_id': value['external_identity_id'],
        'person_id': value['person_id'],
        'status': value['status'],
        'action': value['action'],
        'target': value['target'],
        'requested_at': value['requested_at'] == null ? value['requested_at'] : value['requested_at'].toISOString(),
        'expires_at': value['expires_at'] == null ? value['expires_at'] : value['expires_at'].toISOString(),
        'reason': value['reason'],
        'revert_action': value['revert_action'],
        'revert_action_target': value['revert_action_target'],
        'reverted': value['reverted'],
    };
}

